import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { Alert, Support } from '@app/models';
import { AuthenticationService, SupportService, SharedClickService } from '@app/services';
import { environment } from '@environment/environment';
import Swal from 'sweetalert2';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, first } from 'rxjs';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit, OnDestroy {
    @ViewChild('content') content!: TemplateRef<any>;
    modalRef: NgbModalRef | null = null;

    admin = environment.admin;
    closeResult: string;

    toast = new Alert();

    utilisateur: any;

    action: string;
    me: boolean = false;
    friend: boolean = false;
    src_id: number;//me
    dest_id: number;

    supports: Support[];
    
    submitted: boolean;
    loading: boolean;

    subscription: any; 
    subscriptionNot: any; 
    subscriptionChat: Subscription;

    isUnread: any;

    constructor(
        public translate: TranslateService,
        private authenticationService: AuthenticationService,
        private supportService: SupportService,
        private modalService: NgbModal,
        private sharedClickService: SharedClickService
    ) { }

    // Ouverture du Chat
    speakSupport() {
        if(this.utilisateur.id!=this.admin) {
            this.me = false; 
            this.friend = true;
            this.dest_id = this.admin;
            this.src_id = this.utilisateur.id;//me
        }

        //Lecture de tous les tickets support
        this.readSupports(this.content);
    }

    // Lecture et Mise a jour des supports à lus
    readSupports(content) {
        let body = {
            user_id: this.utilisateur.id//me
        };
        this.supportService.updateSupportsStatusByUser(body)
        .subscribe(
            (res)=>{
                if(res){
                    //refresh supports
                    this.loadSupports(content);
                }
            },
            (err) => {
                Swal.fire({...this.toast, icon: 'error', title: this.translate.instant('Error'), html: err});
                this.loading = false;
            });
    }

    // Messages support non lus
    loadUnreadSupports(body) {
        this.supportService.getUnreadSupportsByDestinataire(body).subscribe(
            (res) => {
                this.isUnread = res;
            }
        );
    }

    // Chargement de la liste des supports
    loadSupports(content=null) {
        this.loading = true;
        let body = {
            dst_id: this.utilisateur.id//me
        };
        this.supportService.getSupportsById(body)
        .pipe(first())
        .subscribe(
          (res)=>{
            if(res){
                this.supports = res;

                //supports non lus
                this.loadUnreadSupports(body);

                if(content) this.modalService.open(content, { fullscreen: true });
                this.loading = false;
            }
          },
          (err) => {
              Swal.fire({...this.toast, icon: 'error', title: this.translate.instant('Error'), html: err});
              this.loading = false;
          });
    }

    // Alerte des messages non lus par ticket
    checkReadStatus(){
        return this.isUnread && this.isUnread.length > 0;
    }

    ngOnInit(): void {
        this.action = 'sent';
        
        //sub chat click
        this.subscriptionChat = this.sharedClickService.triggerSupportClick
        .pipe(first())
        .subscribe(
            () => {
                this.speakSupport();
            }
        );

        //sub user changes
        this.subscription = this.authenticationService.currentUserValue
        .pipe(first())
        .subscribe(
            (res) => {
                if(res){
                    this.utilisateur = res;
                    if(this.utilisateur) this.loadSupports();
                }
            }
        );
    }

    ngOnDestroy(): void {
        if(this.subscription) this.subscription.unsubscribe();
        if(this.subscriptionNot) this.subscriptionNot.unsubscribe();
        if(this.subscriptionChat) this.subscriptionChat.unsubscribe();
    }
}